(function () {
  function moneyNlFromCents(cents) {
    try {
      const v = new Intl.NumberFormat('nl-BE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
      return '€' + v;
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function readProductJson(stickyEl) {
    const jsonEl = stickyEl.querySelector('[data-neuf-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function findATCContext() {
    const form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form.product-form');

    if (!form) return null;

    const submit =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector('[type="submit"]');

    const idInput = form.querySelector('input[name="id"]');

    return { form, submit, idInput };
  }

  function scrollToVariantPicker(form) {
    const target = form.querySelector('select') || form.querySelector('fieldset') || form;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const firstSelect = target.querySelector && target.querySelector('select');
    if (firstSelect) firstSelect.focus({ preventScroll: true });
  }

  /**
   * Probeert de echte “live” prijs te pakken die je theme al rendert/updatet
   * (dus inclusief kortingen, compare-at, etc.)
   */
  function getLivePriceText() {
    const candidates = [
      // meest typische wrappers
      '[data-price]',
      '.price',
      'product-price',
      // fallback: iets met "price" in class
      '[class*="price"]',
    ];

    let live = null;
    for (const sel of candidates) {
      live = document.querySelector(sel);
      if (live) break;
    }
    if (!live) return null;

    // probeer eerst sale prijs, anders regular
    const sale = live.querySelector('.price__sale, .price-item--sale');
    const regular = live.querySelector('.price__regular, .price-item--regular, .price-item');
    const node = sale || regular || live;

    const txt = (node.textContent || '').trim().replace(/\s+/g, ' ');
    return txt || null;
  }

  function init() {
    const sticky = document.querySelector('[data-neuf-sticky-atc]');
    if (!sticky) return;

    const ctx = findATCContext();
    if (!ctx || !ctx.submit || !ctx.form || !ctx.idInput) return;

    const productJson = readProductJson(sticky);
    if (!productJson || !Array.isArray(productJson.variants)) return;

    const elVariant = sticky.querySelector('[data-neuf-sticky-variant]');
    const elPrice = sticky.querySelector('[data-neuf-sticky-price]');
    const btn = sticky.querySelector('[data-neuf-sticky-btn]');
    const stickySelect = sticky.querySelector('[data-neuf-sticky-variant-select]');

    if (!btn) return;

    function getVariantById(id) {
      const vid = Number(id);
      return productJson.variants.find((v) => Number(v.id) === vid) || null;
    }

    function syncTextsByVariantId(variantId) {
      const v = variantId ? getVariantById(variantId) : null;

      if (v) {
        if (elVariant) {
          elVariant.textContent =
            v.title && v.title !== 'Default Title' ? v.title : 'Geselecteerd';
        }

        // 1) live prijs (incl korting) als die bestaat
        // 2) fallback variant price uit JSON
        const livePrice = getLivePriceText();
        if (elPrice) elPrice.textContent = livePrice || moneyNlFromCents(v.price);
      } else {
        if (elVariant) elVariant.textContent = 'Maak een keuze';
        if (elPrice) elPrice.textContent = '';
      }
    }

    function syncStickySelectFromMain() {
      if (!stickySelect) return;
      const vId = ctx.idInput.value;
      if (!vId) return;

      const opt = stickySelect.querySelector(`option[value="${CSS.escape(vId)}"]`);
      if (opt && !opt.disabled) {
        stickySelect.value = vId;
      }
    }

    function setMainVariantFromStickySelect() {
      if (!stickySelect) return;
      const vId = stickySelect.value;
      if (!vId) return;

      ctx.idInput.value = vId;
      ctx.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      ctx.idInput.dispatchEvent(new Event('input', { bubbles: true }));

      // variant title + prijs meteen updaten
      syncTextsByVariantId(vId);
    }

    function syncAllFromMain() {
      const vId = ctx.idInput.value || '';
      syncTextsByVariantId(vId);
      syncStickySelectFromMain();
    }

    function show() {
      sticky.hidden = false;
      sticky.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => sticky.classList.add('is-visible'));
    }

    function hide() {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => {
        sticky.hidden = true;
      }, 220);
    }

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) hide();
        else show();
      },
      { threshold: 0.15 }
    );

    io.observe(ctx.submit);

    ctx.form.addEventListener('change', syncAllFromMain, { passive: true });
    ctx.form.addEventListener('input', syncAllFromMain, { passive: true });

    if (stickySelect) {
      stickySelect.addEventListener('change', setMainVariantFromStickySelect);
    }

    btn.addEventListener('click', () => {
      // Geen auto-select: als sticky select leeg is, scroll naar picker
      if (stickySelect && !stickySelect.value) {
        scrollToVariantPicker(ctx.form);
        return;
      }

      const vid = ctx.idInput.value || '';
      if (!vid) {
        scrollToVariantPicker(ctx.form);
        return;
      }

      ctx.submit.click();
    });

    syncAllFromMain();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();